import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  addNewContainerButton: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: "4px",
  },
  containerActionIcon: {
    cursor: "pointer",
    marginBottom: "4px",
  },
  fieldWhenInEditCreateMode: {
    paddingRight: "16px",
  },
}));

export default styles;
